import CONFIG from '../config';

export const poll = (fn: () => boolean, timeout: number, interval: number) => {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise<boolean>(checkCondition);
};

export const getSeeAllGamesLink = ( countryCode: string, accessFilter?: string): string => {
  return `${CONFIG.isUPC ? '/upc' : ''}${countryCode === 'uk' ? '' : `/${countryCode}`}/ubisoftplus/games?${(accessFilter !== undefined) ? '&access=' + accessFilter : ''}`
};



export const getNavigationPageLink = (countryCode: string, key: string) => {
  let parsedCountryCode = countryCode === 'uk' ? '' : `${countryCode}/`;
  //Different link for ncsa
  let isDifferentLink =  CONFIG.isUPC && (countryCode === 'us' || countryCode === 'ca');
  const LANDING_PAGE_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus`;
  const GAMES_LINK = getSeeAllGamesLink(countryCode);
  const REWARDS_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus${isDifferentLink  ? '-' : '/'}rewards`;

  switch (key) {
    case 'landing':
      return LANDING_PAGE_LINK;
    case 'games' :
      return GAMES_LINK;
    case 'rewards' :
      return REWARDS_LINK;
    default:
      break;
  }
};

export const pollGeoRestrictedResources = async () => {
  try {
    await poll(
      () => {
        return (window as any).GeoRestrictedResources;
      },
      2000,
      150
    );

    return (window as any).GeoRestrictedResources;
  } catch (error) {
    return null;
  }
};

export const pollContants = async () => {
  try {
    await poll(
      () => {
        return (window as any).Constants;
      },
      2000,
      150
    );

    return (window as any).Constants;
  } catch (error) {
    return null;
  }
};

export const getFAQUrl = async () => {
  try {
    const uplayDataAvailable = await poll(
      () => (window as any).uplayData,
      2000,
      250
    );
    if (!uplayDataAvailable) {
      throw new Error();
    }

    return `https://support.ubi.com/${
      (window as any).uplayData.locale
    }/Games/6188`;
  } catch (error) {
    return 'https://support.ubi.com/en-US/Games/50001';
  }
};

//Returns Image object used by PictureImage
export const getImage = (imageLink : string) => {
  return [
    {
      imageName: imageLink + '_desktop',
      minWidth: 1095
    },
    {
      imageName: imageLink + '_tablet',
      minWidth: 600
    },
    {
      imageName: imageLink + '_mobile',
      minWidth: 0
    },
  ];
}

export const setUpWaData = async () => {
  try {
    const waDataAvailable = await poll(
      () => (window as any).wa_data,
      2000,
      150
    );
    if (!waDataAvailable) {
      throw new Error();
    }

    (window as any).wa_data = {
      ...(window as any).wa_data,
      pageName: 'ubisoft plus',
      siteSection: 'product page',
      game: 'ubisoft plus',
      brand: 'ubisoft plus',
      producttype: 'subscription',
      product: {...(window as any).wa_data.product,productID :'5c12949ad9d14601d43eea96' }
    };
  } catch (error) {
    console.log('WA_DATA not defined');
  }
};

export const adobeTrack = (event: string, action: string) => {
  if (process.env.NODE_ENV === 'production') {
    // (window as any).tc_events_100(null, event, { ACTION: action });
  }
};
